import { createSlice } from '@reduxjs/toolkit';

export const agentesSlice = createSlice({
    name: 'agentes',
    initialState: {
        agent_list: [],
        agent: {},
        form_options: {}
    },
    reducers: {
        setAgentesListRedux: ( state, { payload } ) => {
            state.agent_list  =  payload;
        }, 
        setAgenteRedux: ( state, { payload } ) => {
            state.agent  =  payload; 
        },
        setFormOptionsRedux: ( state, { payload } ) => {
            state.form_options = payload;
        }
    }
});

// Action creators are generated for each case reducer function
export const { setAgentesListRedux, setAgenteRedux, setFormOptionsRedux } = agentesSlice.actions;
